import { format, startOfMonth } from 'date-fns';

const DATE_YMD_RE = /^\d{4}-\d{2}-\d{2}$/;

export function todayYmd(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

export function startOfCurrentMonthYmd(): string {
  return format(startOfMonth(new Date()), 'yyyy-MM-dd');
}

export function defaultPeriod(): { from: string; to: string } {
  return { from: startOfCurrentMonthYmd(), to: todayYmd() };
}

export function isValidYmd(value: unknown): value is string {
  return typeof value === 'string' && DATE_YMD_RE.test(value);
}

export function normalizePeriod(from?: unknown, to?: unknown): {
  from: string;
  to: string;
} {
  const defaults = defaultPeriod();
  const parsedFrom = isValidYmd(from) ? from : defaults.from;
  const parsedTo = isValidYmd(to) ? to : defaults.to;
  if (parsedFrom > parsedTo) {
    return { from: parsedTo, to: parsedFrom };
  }
  return { from: parsedFrom, to: parsedTo };
}
